import React from "react";
import { Link } from "react-router-dom";
import { MasterData } from "../../core/json/master";
import ImageWithBasePath from "../../core/img/imagewithbasebath";
import { hasPermission } from "core/Operations/checkPermission";
import { selectUserPermissions } from "core/redux/slice/userPermissionSlice";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
import "../../style/css/master.css";
const MasterList = () => {
  const userData = useSelector(loggedInUser);
  // const permissions = useSelector(selectUserPermissions) || [];
  const permissions = userData?.permissions;

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="page-title">
              <h4>Master</h4>
              <h6>Manage your master data</h6>
            </div>
          </div>
          <div className="card border-0">
            <div className="card-body">
              <div className="row">
                {MasterData.map(
                  (data, index) =>
                    hasPermission(
                      permissions,
                      data.module,
                      data.accessCode || data.linkText,
                      "haveView"
                    ) && (
                      <div className="col-lg-2 col-sm-6 col-12 " key={index}>
                        <div
                          className="card master-card"
                          style={{
                            borderRadius: "0px",
                          }}
                        >
                          <div
                            className="card-header"
                            style={{
                              backgroundColor: "",
                              borderRadius: "0px",
                            }}
                          >
                            <h5 className="card-title text-center">
                              <ImageWithBasePath
                                src={`${data.iconPath}${data.icon}`}
                                // src="assets/img/icons/dash1.svg"
                                width="40px"
                              />
                            </h5>
                          </div>
                          <div
                            className="card-body master-body"
                            style={{
                              textAlign: "center",
                            }}
                          >
                            <Link to={data.link} className="master-title">
                              {data.linkText}
                            </Link>
                          </div>
                        </div>
                      </div>
                    )
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MasterList;
